(function(){
  function normalize(value){return String(value).toLocaleLowerCase('da').replace(/æ/g,'ae').replace(/ø/g,'oe').replace(/å/g,'aa').normalize('NFD').replace(/[\u0300-\u036f]/g,'').replace(/\bmagnesum\b/g,'magnesium');}
  function init(root){
    const library=root.querySelector('.nuro-library');
    const tools=root.querySelector('[data-library-tools]');
    if(!library||!tools||tools.dataset.ready)return;
    const input=tools.querySelector('input');
    const status=tools.querySelector('[role="status"]');
    const empty=root.querySelector('[data-library-empty]');
    const toc=root.querySelector('.nuro-toc');
    const groups=Array.from(library.querySelectorAll('ul')).filter(ul=>!ul.closest('.nuro-faq'));
    const items=groups.flatMap(ul=>Array.from(ul.children).filter(li=>li.querySelector('a')));
    if(items.length<8)return;
    tools.dataset.ready='true';tools.hidden=false;
    function filter(){
      const term=normalize(input.value.trim());let count=0;
      for(const item of items){const match=!term||normalize(item.textContent).includes(term);item.hidden=!match;if(match)count++;}
      for(const group of groups){
        const heading=group.previousElementSibling;
        const hasVisible=Array.from(group.children).some(li=>!li.hidden);
        group.hidden=!hasVisible;
        if(heading&&heading.tagName==='H2')heading.hidden=!hasVisible;
      }
      status.textContent=term?count+' links matcher din søgning.':items.length+' links i oversigten.';
      if(empty)empty.hidden=count>0;
      if(toc&&toc.querySelector('li'))toc.hidden=Boolean(term);
    }
    input.addEventListener('input',filter);filter();
  }
  document.querySelectorAll('.nuro-page').forEach(init);
  document.addEventListener('shopify:section:load',event=>{if(event.target.matches('.nuro-page'))init(event.target);else event.target.querySelectorAll('.nuro-page').forEach(init);});
})();
